//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AssociateObjects",0,"SelectNXObjectList",0],[0,"AvoidViewRoll",1,0],[1,"CameraAngle",0,"Expression",0],[0,"CameraAxisType",1,0],[0,"CameraModeType",1,0],[0,"CameraOrientation",1,"NXObject",0],[0,"DirectionType",1,0],[0,"EndPathPoint",1,"Point",0],[1,"EndTime",0,"Expression",0],[1,"LookAtObject",0,"SelectNXObject",0],[0,"Name",1,0],[0,"PointOnLookAtRigid",1,"Point",0],[1,"RotationSpeed",0,"Expression",0],[0,"SpecifyTime",1,0],[0,"StartPathPoint",1,"Point",0],[1,"StartTime",0,"Expression",0],[0,"TransitionModeType",1,0]],[[["currentTime"],"CreatePOV",{},1,0],[["pos"],"UpdatePOV",{},1,0],[["povs"],"DeletePOVs",{},1,0],[["pos","name"],"SetPOVName",{},2,0],[["pos","start_time"],"SetPOVStartTime",{},2,0],[["pos","step_num"],"SetPOVStepNumber",{},2,0],[["fViewScale"],"SetViewScale",{},1,0],[["curves"],"EvaluatePath",{},1,0],[["rotation","translation","scale"],"UpdateCurrentView",{},3,0],[["time"],"PlayKeyFrameAtTime",{},1,0]],[]];
SPLM.Mechatronics.AnimatedCameraBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.AnimatedCameraBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.AnimatedCameraBuilder.CameraModeTypes = Object.freeze({
    "UserDefined" : "UserDefined", "Turntable" : "Turntable", "Trajectory" : "Trajectory"});

SPLM.Mechatronics.AnimatedCameraBuilder.CameraAxisTypes = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.Mechatronics.AnimatedCameraBuilder.TransitionModeTypes = Object.freeze({
    "Linear" : "Linear", "Path" : "Path"});

SPLM.Mechatronics.AnimatedCameraBuilder.LookAtDirectionTypes = Object.freeze({
    "WithRigid" : "WithRigid", "AlongPath" : "AlongPath", "LookAtObject" : "LookAtObject", "Fixed" : "Fixed"});

export default SPLM;